module.exports = __webpack_public_path__ + "img/Xraised.325ace91.jpg";